import { browseRootPath } from "@outschool/routes";

import * as Routes from "../../shared/Routes";

export type TeacherSettingsAccessUser = {
  teacher_approved_at?: unknown;
  is_admin?: boolean | null;
  sellerOrg?: {
    currentUserIsOwner?: boolean | null;
    currentUserIsTeacher?: boolean | null;
  } | null;
};

export type TeacherCredentialsDestination =
  | "teacherSettings"
  | "legacy"
  | "sellerOrg"
  | "browse";

function canUseTeacherSettingsNavigation(
  currentUser: TeacherSettingsAccessUser | null | undefined,
) {
  return (
    !currentUser?.is_admin &&
    !currentUser?.sellerOrg?.currentUserIsOwner &&
    !currentUser?.sellerOrg?.currentUserIsTeacher
  );
}

export function canUseEmbeddedTeacherCredentials(
  currentUser: TeacherSettingsAccessUser | null | undefined,
) {
  return (
    !!currentUser?.teacher_approved_at &&
    canUseTeacherSettingsNavigation(currentUser)
  );
}

export function getTeacherSettingsNavigationPolicy(
  currentUser: TeacherSettingsAccessUser | null | undefined,
  isEducatorEsaHubEnabled: boolean,
) {
  const usesSettingsNavigation =
    isEducatorEsaHubEnabled && canUseTeacherSettingsNavigation(currentUser);
  const canAccessCredentials =
    !!currentUser?.teacher_approved_at ||
    !!currentUser?.is_admin ||
    !!currentUser?.sellerOrg?.currentUserIsOwner ||
    !!currentUser?.sellerOrg?.currentUserIsTeacher;

  return {
    canAccessCredentials,
    isEducatorEsaHubEnabled,
    usesSettingsNavigation,
    usesEmbeddedCredentials:
      isEducatorEsaHubEnabled && canUseEmbeddedTeacherCredentials(currentUser),
  };
}

export function teacherCredentialsDestination(
  currentUser: TeacherSettingsAccessUser | null | undefined,
  isEducatorEsaHubEnabled: boolean,
): TeacherCredentialsDestination {
  const policy = getTeacherSettingsNavigationPolicy(
    currentUser,
    isEducatorEsaHubEnabled,
  );
  if (currentUser?.sellerOrg?.currentUserIsOwner) {
    return "sellerOrg";
  }
  if (policy.usesEmbeddedCredentials) {
    return "teacherSettings";
  }
  if (policy.canAccessCredentials) {
    return "legacy";
  }
  return "browse";
}

export function teacherCredentialsDestinationPath(
  destination: TeacherCredentialsDestination,
  search = "",
) {
  switch (destination) {
    case "teacherSettings":
      return `${Routes.teacherSettingsCredentialsPath()}${search}`;
    case "legacy":
      return `${Routes.teacherUploadCredentialsPath()}${search}`;
    case "sellerOrg":
      return Routes.sellerOrgCredentialsPath();
    case "browse":
      return browseRootPath();
  }
}
